import { AxiosError } from "axios";
import { axiosInstance } from "../../../../common/utils/axios_instance";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import { getProjetoListRequest, getProjetoListResponse } from "../daos/read/get_all_projetos_list";
import { IProjetosService } from "./projetos_service";
import { GetAllProjetosChecklistRequest, GetAllProjetosChecklistResponse } from "../daos/read/get_all_projetos_checklist";
import { CreateProjetosChecklistRequest, CreateProjetosChecklistResponse } from "../daos/create/create_projetos_checklist";
import { GetProjetosChecklistByIdRequest, GetProjetosChecklistByIdResponse } from "../daos/read/get_projetos_checklist_by_id";
import { UpdateProjetosChecklistRequest, UpdateProjetosChecklistResponse } from "../daos/update/update_projetos_checklist";
import { DeleteProjetosChecklistRequest, DeleteProjetosChecklistResponse } from "../daos/delete/delete_projetos_checklist";
import { GetAllItensChecklistRequest, GetAllItensChecklistResponse } from "../daos/read/get_all_itens_checklist";
import { CreateItensChecklistRequest, CreateItensChecklistResponse } from "../daos/create/create_itens_checklist";
import { GetItensChecklistByIdRequest, GetItensChecklistByIdResponse } from "../daos/read/get_itens_checklist_by_id";
import { UpdateItensChecklistRequest, UpdateItensChecklistResponse } from "../daos/update/update_itens_checklist";
import { DeleteItensChecklistRequest, DeleteItensChecklistResponse } from "../daos/delete/delete_itens_checklist";
import { GetProjetoByIdRequest, GetProjetoByIdResponse } from "../daos/read/get_projeto_by_id";
import { CreateProjetoRequest, CreateProjetoResponse } from "../daos/create/create_projeto";
import { UpdateProjetoRequest, UpdateProjetoResponse } from "../daos/update/update_projeto";
import { DeleteProjetoRequest, DeleteProjetoResponse } from "../daos/delete/delete_projeto";
import { GetAllProjetoArquivoRequest, GetAllProjetoArquivoResponse } from "../daos/read/get_all_projeto_arquivo";
import { GetProjetoArquivoByIdRequest } from "../daos/read/get_projeto_arquivo_by_id";
import { CreateProjetoArquivoRequest, CreateProjetoArquivoResponse } from "../daos/create/create_projeto_arquivo";
import { UpdateProjetoArquivoRequest, UpdateProjetoArquivoResponse } from "../daos/update/update_projeto_arquivo";
import { DeleteProjetoArquivoRequest, DeleteProjetoArquivoResponse } from "../daos/delete/delete_projeto_arquivo";
import { GetAllProjetoInformacoesRequest, GetAllProjetoInformacoesResponse } from "../daos/read/get_all_projeto_informacoes";
import { GetProjetoInformacoesByIdRequest, GetProjetoInformacoesByIdResponse } from "../daos/read/get_projeto_informacoes_by_id";
import { CreateProjetoInformacoesRequest, CreateProjetoInformacoesResponse } from "../daos/create/create_projeto_informacoes";
import { UpdateProjetoInformacoesRequest, UpdateProjetoInformacoesResponse } from "../daos/update/update_projeto_informacoes";
import { DeleteProjetoInformacoesRequest, DeleteProjetoInformacoesResponse } from "../daos/delete/delete_projeto_informacoes";
import { GetAllProjetoDisciplinasRequest, GetAllProjetoDisciplinasResponse } from "../daos/read/get_all_disciplina";
import { CreateProjetoDisciplinaRequest, CreateProjetoDisciplinaResponse } from "../daos/create/create_projeto_disciplina";
import { DeleteProjetoDisciplinaRequest, DeleteProjetoDisciplinaResponse } from "../daos/delete/delete_projeto_disciplina";
import { GetProjetoDisciplinaByIdRequest, GetProjetoDisciplinaByIdResponse } from "../daos/read/get_projeto_disciplina_by_id";
import { UpdateProjetoDisciplinaRequest, UpdateProjetoDisciplinaResponse } from "../daos/update/update_projeto_disciplina";
import { GetDropDownChecklistRequest, GetDropDownChecklistResponse } from "../daos/read/get_drop_down_checklist";
import { GetDropDownDisciplinaRequest, GetDropDownDisciplinaResponse } from "../daos/read/get_drop_down_disciplina";
import { GetAllDisciplinaChecklistRequest, GetAllDisciplinaChecklistResponse } from "../daos/read/get_all_disciplina_itens_checklist";
import { UpdateDisciplinaChecklistRequest, UpdateDisciplinaChecklistResponse } from "../daos/update/update_disciplina_itens_checklist";
import { GetAllDisciplinasArquivosRequest, GetAllDisciplinasArquivosResponse } from "../daos/read/get_all_disciplinas_arquivos";
import { GetDisciplinasArquivosByIdRequest, GetDisciplinasArquivosByIdResponse } from "../daos/read/get_disciplinas_arquivos_by_id";
import { CreateDisciplinasArquivosRequest, CreateDisciplinasArquivosResponse } from "../daos/create/create_disciplinas_arquivos";
import { UpdateDisciplinasArquivosRequest, UpdateDisciplinasArquivosResponse } from "../daos/update/update_disciplinas_arquivos";
import { DeleteDisciplinasArquivosRequest, DeleteDisciplinasArquivosResponse } from "../daos/delete/delete_disciplinas_arquivos";
import { CreateProjetoImpressaoRequest } from "../daos/create/create_projeto_impressao";
import { GetAllProjetoImpressaoRequest, GetAllProjetoImpressaoResponse } from "../daos/read/get_all_projeto_impressao";
import { UpdateProjetoImpressaoRequest, UpdateProjetoImpressaoResponse } from "../daos/update/update_projeto_impressao";
import { GetProjetoImpressaoByIdRequest, GetProjetoImpressaoByIdResponse } from "../daos/read/get_projeto_impressao_by_id";
import { CreateProjetoRevisaoRequest, CreateProjetoRevisaoResponse } from "../daos/create/create_projeto_revisao";
import { GetAllProjetoRevisaoRequest, GetAllProjetoRevisaoResponse } from "../daos/read/get_all_projeto_revisao";
import { GetProjetoRevisaoByIdRequest, GetProjetoRevisaoByIdResponse } from "../daos/read/get_projeto_revisao_by_id";
import { UpdateProjetoRevisaoRequest, UpdateProjetoRevisaoResponse } from "../daos/update/update_projeto_revisao";
import { SendEmailProjetoRequest, SendEmailProjetoResponse } from "../daos/read/send_email_projeto";
import { DeleteDisciplinaChecklistRequest, DeleteDisciplinaChecklistResponse } from "../daos/delete/delete_disciplina_checklist";
import { CreateProjetoResumoRevisaoRequest, CreateProjetoResumoRevisaoResponse } from "../daos/create/create_projeto_revisao_resumo";
import { UpdateProjetoRevisaoResumoRequest, UpdateProjetoRevisaoResumoResponse } from "../daos/update/update_projeto_revisao_resumo";
import { GetAllProjetoRevisaoResumoRequest, GetAllProjetoRevisaoResumoResponse } from "../daos/read/get_all_projeto_revisao_resumo";
import { DeleteProjetoRevisaoResumoRequest, DeleteProjetoRevisaoResumoResponse } from "../daos/delete/delete_projeto_revisao_resumo";
import { GetDisciplinasSubdisciplinasByProjetoRequest, GetDisciplinasSubdisciplinasByProjetoResponse } from "../daos/read/get_disciplinas_subdisciplinas_Projeto";
import { SendEmailProjetoImpressaoRequest, SendEmailProjetoImpressaoResponse } from "../daos/read/send_email_projeto_impressao";
import { DisciplinaCopiaRequest, DisciplinaCopiaResponse } from "../daos/create/disciplinas_copia";
import { GetEmailImpressaoParametersRequest, GetEmailImpressaoParametersResponse } from "../daos/read/get_email_impressao_parameters";
import { RequestObjectToFormData } from "../../../../common/utils/form_data_utils";
import { GetDashboardProjetosInfoRequest, GetDashboardProjetosInfoResponse } from "../daos/read/get_dashboard_projetos_info";
import { DownloadArquivoS3Request } from "../../../../common/data/daos/read/downloadArquivoS3";
import { GetArquivoDisciplinaRequest } from "../daos/read/get_arquivo_disciplinas_arquivos";



export class ProjetosService implements IProjetosService {
  //#region Projeto
  async getProjetoList(request: getProjetoListRequest): Promise<getProjetoListResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/list`, request);
      const response = handleAxiosResponse<getProjetoListResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getProjetoById(request: GetProjetoByIdRequest): Promise<GetProjetoByIdResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/get-by-id`, request);
      return handleAxiosResponse<GetProjetoByIdResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async createProjeto(request: CreateProjetoRequest): Promise<CreateProjetoResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/create`, request);
      const response = handleAxiosResponse<CreateProjetoResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async updateProjeto(request: UpdateProjetoRequest): Promise<UpdateProjetoResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/update`, request);
      return handleAxiosResponse<UpdateProjetoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  async deleteProjeto(request: DeleteProjetoRequest): Promise<DeleteProjetoResponse> {
    try {
      const result = await axiosInstance({}).delete(`/projetos/delete`, { data: request });
      return handleAxiosResponse<DeleteProjetoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      if (isBaseError(error)) throw toBaseError(error);
      if (error instanceof AxiosError) throw new Error(error.message);
      if (error instanceof Error) throw error;
      throw new Error("Falha ao executar requisição!");
    }
  }

  //#endregion

  //#region Checklist

  async getAllProjetosChecklist(request: GetAllProjetosChecklistRequest): Promise<GetAllProjetosChecklistResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/checklist/list`, request);

      return handleAxiosResponse<GetAllProjetosChecklistResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async createProjetosChecklist(request: CreateProjetosChecklistRequest): Promise<CreateProjetosChecklistResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/checklist/create`, request);

      return handleAxiosResponse<CreateProjetosChecklistResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async getByIdProjetosChecklist(request: GetProjetosChecklistByIdRequest): Promise<GetProjetosChecklistByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/projetos/checklist/getbyid/${request.id}`);

      return handleAxiosResponse<GetProjetosChecklistByIdResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async updateProjetosChecklist(request: UpdateProjetosChecklistRequest): Promise<UpdateProjetosChecklistResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/checklist/update`, request);

      return handleAxiosResponse<UpdateProjetosChecklistResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async deleteProjetosChecklist(request: DeleteProjetosChecklistRequest): Promise<DeleteProjetosChecklistResponse> {
    try {
      const result = await axiosInstance({}).delete(`/projetos/checklist/delete/`, { data: request });

      return handleAxiosResponse<DeleteProjetosChecklistResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async getDropDownChecklist(request: GetDropDownChecklistRequest): Promise<GetDropDownChecklistResponse[]> {
    try {
      const result = await axiosInstance({}).get(`/projetos/checklist/dropdown`);
      return handleAxiosResponse<GetDropDownChecklistResponse[]>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  //#endregion

  //#region Items Checklist

  async getAllItensChecklist(request: GetAllItensChecklistRequest): Promise<GetAllItensChecklistResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/itemchecklist/list`, request);
      return handleAxiosResponse<GetAllItensChecklistResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async createItensChecklist(request: CreateItensChecklistRequest): Promise<CreateItensChecklistResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/itemchecklist/create`, request);
      return handleAxiosResponse<CreateItensChecklistResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async getByIdItensChecklist(request: GetItensChecklistByIdRequest): Promise<GetItensChecklistByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/projetos/itemchecklist/getbyid/${request.id}`);
      return handleAxiosResponse<GetItensChecklistByIdResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async updateItensChecklist(request: UpdateItensChecklistRequest): Promise<UpdateItensChecklistResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/itemchecklist/update`, request);
      return handleAxiosResponse<UpdateItensChecklistResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async deleteItensChecklist(request: DeleteItensChecklistRequest): Promise<DeleteItensChecklistResponse> {
    try {
      const result = await axiosInstance({}).delete(`/projetos/itemchecklist/delete`, { data: request });
      return handleAxiosResponse<DeleteItensChecklistResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  //#endregion

  //#region ProjetoArquivo


  async getAllProjetoArquivo(request: GetAllProjetoArquivoRequest): Promise<GetAllProjetoArquivoResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/projetoarquivo/list`, request);
      return handleAxiosResponse<GetAllProjetoArquivoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async getProjetoArquivoById(request: GetProjetoArquivoByIdRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: 'blob' }).get(`/projetos/projetoarquivo/getbyid/${request.id}`);
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async createProjetoArquivo(request: CreateProjetoArquivoRequest): Promise<CreateProjetoArquivoResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { 'Content-Type': 'multipart/form-data' } };

      const result = await axiosInstance({}).post(`/projetos/projetoarquivo/create`, formData, options);
      return handleAxiosResponse<CreateProjetoArquivoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async updateProjetoArquivo(request: UpdateProjetoArquivoRequest): Promise<UpdateProjetoArquivoResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { 'Content-Type': 'multipart/form-data' } };
      const result = await axiosInstance({}).post(`/projetos/projetoarquivo/update`, formData, options);
      return handleAxiosResponse<UpdateProjetoArquivoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async deleteProjetoArquivo(request: DeleteProjetoArquivoRequest): Promise<DeleteProjetoArquivoResponse> {
    try {
      const result = await axiosInstance({}).delete(`/projetos/projetoarquivo/${request.IdProjetoArquivo}/delete`, { data: request });
      return handleAxiosResponse<DeleteProjetoArquivoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  //#endregion

  //#region ProjetoInformacoes

  async getAllProjetoInformacoes(request: GetAllProjetoInformacoesRequest): Promise<GetAllProjetoInformacoesResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/informacoes/list`, request);
      return handleAxiosResponse<GetAllProjetoInformacoesResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async getProjetoInformacoesById(request: GetProjetoInformacoesByIdRequest): Promise<GetProjetoInformacoesByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/projetos/informacoes/getbyid/${request.id}`);
      return handleAxiosResponse<GetProjetoInformacoesByIdResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async createProjetoInformacoes(request: CreateProjetoInformacoesRequest): Promise<CreateProjetoInformacoesResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/informacoes/create`, request);
      return handleAxiosResponse<CreateProjetoInformacoesResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async updateProjetoInformacoes(request: UpdateProjetoInformacoesRequest): Promise<UpdateProjetoInformacoesResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/informacoes/update`, request);
      return handleAxiosResponse<UpdateProjetoInformacoesResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async deleteProjetoInformacoes(request: DeleteProjetoInformacoesRequest): Promise<DeleteProjetoInformacoesResponse> {
    try {
      const result = await axiosInstance({}).delete(`/projetos/informacoes/delete/`, { data: request });
      return handleAxiosResponse<DeleteProjetoInformacoesResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  //#endregion

  //#region Disciplina

  async getAllProjetoDisciplinas(request: GetAllProjetoDisciplinasRequest): Promise<GetAllProjetoDisciplinasResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/disciplina/list`, request);
      return handleAxiosResponse<GetAllProjetoDisciplinasResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async getProjetoDisciplinaById(request: GetProjetoDisciplinaByIdRequest): Promise<GetProjetoDisciplinaByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/projetos/disciplina/getbyid/${request.id}`);
      return handleAxiosResponse<GetProjetoDisciplinaByIdResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }
  async copiaDisciplinas(request: DisciplinaCopiaRequest): Promise<DisciplinaCopiaResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/disciplina/copia`, request);
      return handleAxiosResponse<DisciplinaCopiaResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async createProjetoDisciplina(request: CreateProjetoDisciplinaRequest): Promise<CreateProjetoDisciplinaResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/disciplina/create`, request);
      return handleAxiosResponse<CreateProjetoDisciplinaResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async updateProjetoDisciplina(request: UpdateProjetoDisciplinaRequest): Promise<UpdateProjetoDisciplinaResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/disciplina/update`, request);
      return handleAxiosResponse<UpdateProjetoDisciplinaResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async deleteProjetoDisciplina(request: DeleteProjetoDisciplinaRequest): Promise<DeleteProjetoDisciplinaResponse> {
    try {
      const result = await axiosInstance({}).delete(`/projetos/disciplina/delete/${request.id}`);
      return handleAxiosResponse<DeleteProjetoDisciplinaResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async getDropDownDisciplina(request: GetDropDownDisciplinaRequest): Promise<GetDropDownDisciplinaResponse[]> {
    try {
      const result = await axiosInstance({}).get(`/projetos/disciplina/dropdown/${request.id}`);
      return handleAxiosResponse<GetDropDownDisciplinaResponse[]>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }
  //#endregion
  async deleteDisciplinaChecklist(request: DeleteDisciplinaChecklistRequest): Promise<DeleteDisciplinaChecklistResponse> {
    try {
      const result = await axiosInstance({}).delete(`/projetos/disciplina-checklist/delete`, { data: request });
      return handleAxiosResponse<DeleteDisciplinaChecklistResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async getAllDisciplinaItemsChecklist(request: GetAllDisciplinaChecklistRequest): Promise<GetAllDisciplinaChecklistResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/disciplina-checklist/list`, request);
      return handleAxiosResponse<GetAllDisciplinaChecklistResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async updateDisciplinaChecklist(request: UpdateDisciplinaChecklistRequest): Promise<UpdateDisciplinaChecklistResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { 'Content-Type': 'multipart/form-data' } };
      const result = await axiosInstance({}).post(`/projetos/disciplina-checklist/update`, formData, options);
      return handleAxiosResponse<UpdateDisciplinaChecklistResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }
  async getAllDisciplinaArquivos(request: GetAllDisciplinasArquivosRequest): Promise<GetAllDisciplinasArquivosResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/disciplina-arquivos/list`, request);
      return handleAxiosResponse<GetAllDisciplinasArquivosResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async getByIdDisciplinaArquivo(request: GetDisciplinasArquivosByIdRequest): Promise<GetDisciplinasArquivosByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/projetos/disciplina-arquivos/getbyid/${request.id}`);
      return handleAxiosResponse<GetDisciplinasArquivosByIdResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  // Função não está sendo utilizada, obsoleta.
  async createDisciplinaArquivo(request: CreateDisciplinasArquivosRequest): Promise<CreateDisciplinasArquivosResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { 'Content-Type': 'multipart/form-data' } };

      const result = await axiosInstance({}).post(`/projetos/disciplina-arquivos/create`, formData, options);
      return handleAxiosResponse<CreateDisciplinasArquivosResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async updateDisciplinaArquivo(request: UpdateDisciplinasArquivosRequest): Promise<UpdateDisciplinasArquivosResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { 'Content-Type': 'multipart/form-data' } };

      const result = await axiosInstance({}).post(
        `/projetos/disciplina-arquivos/update`,
        formData,
        options);
      return handleAxiosResponse<UpdateDisciplinasArquivosResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async deleteDisciplinaArquivo(idDisciplina: DeleteDisciplinasArquivosRequest): Promise<DeleteDisciplinasArquivosResponse> {
    try {
      const result = await axiosInstance({}).delete(`/projetos/disciplina-arquivos/delete/${idDisciplina.id}`, { data: idDisciplina });

      return handleAxiosResponse<DeleteDisciplinasArquivosResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }


  //#region ProjetoImpressao
  async getEmailImpressaoParameters(request: GetEmailImpressaoParametersRequest): Promise<GetEmailImpressaoParametersResponse> {
    try {
      const result = await axiosInstance({}).get(`/projetos/projetoimpressao/email-parameters/${request.idProjetoImpressao}`);
      return handleAxiosResponse<GetEmailImpressaoParametersResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }

  }

  async sendEmailProjetoImpressao(request: SendEmailProjetoImpressaoRequest): Promise<SendEmailProjetoImpressaoResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/projetoimpressao/send-email`, request);
      return handleAxiosResponse<SendEmailProjetoImpressaoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async getAllProjetoImpressao(request: GetAllProjetoImpressaoRequest): Promise<GetAllProjetoImpressaoResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/projetoimpressao/list`, request);
      return handleAxiosResponse<GetAllProjetoImpressaoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async getProjetoImpressaoById(request: GetProjetoImpressaoByIdRequest): Promise<GetProjetoImpressaoByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/projetos/projetoimpressao/getbyid/${request.id}`);
      return handleAxiosResponse<GetProjetoImpressaoByIdResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async createProjetoImpressao(request: CreateProjetoImpressaoRequest): Promise<{ idProjetoImpressao: number }> {
    try {
      const result = await axiosInstance({}).post(`/projetos/projetoimpressao/create`, request);
      return handleAxiosResponse<{ idProjetoImpressao: number }>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async updateProjetoImpressao(request: UpdateProjetoImpressaoRequest): Promise<UpdateProjetoImpressaoResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/projetoimpressao/update`, request);
      return handleAxiosResponse<UpdateProjetoImpressaoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async deleteProjetoImpressao(request: { id: number }): Promise<void> {
    try {
      const result = await axiosInstance({}).delete(`/projetos/projetoimpressao/delete/${request.id}`);
      return handleAxiosResponse<void>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  //#endregion

  //#region ProjetoRevisao

  async getAllProjetoRevisao(request: GetAllProjetoRevisaoRequest): Promise<GetAllProjetoRevisaoResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/projetorevisao/list`, request);
      return handleAxiosResponse<GetAllProjetoRevisaoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async getProjetoRevisaoById(request: GetProjetoRevisaoByIdRequest): Promise<GetProjetoRevisaoByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/projetos/projetorevisao/getbyid/${request.id}`);
      return handleAxiosResponse<GetProjetoRevisaoByIdResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async createProjetoRevisao(request: CreateProjetoRevisaoRequest): Promise<CreateProjetoRevisaoResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      const result = await axiosInstance({}).post(`/projetos/projetorevisao/create`, formData, config);
      return handleAxiosResponse<CreateProjetoRevisaoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async updateProjetoRevisao(request: UpdateProjetoRevisaoRequest): Promise<UpdateProjetoRevisaoResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/projetorevisao/update`, request);
      return handleAxiosResponse<UpdateProjetoRevisaoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async getDisciplinasSubdisciplinasByProjeto(request: GetDisciplinasSubdisciplinasByProjetoRequest)
    : Promise<GetDisciplinasSubdisciplinasByProjetoResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/disciplinas-subdisciplinas`, request);
      const response = handleAxiosResponse<GetDisciplinasSubdisciplinasByProjetoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteProjetoRevisao(request: { id: number }): Promise<void> {
    try {
      const result = await axiosInstance({}).delete(`/projetos/projetorevisao/delete/${request.id}`);
      return handleAxiosResponse<void>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async sendEmailProjeto({ idProjeto, ...request }: SendEmailProjetoRequest): Promise<SendEmailProjetoResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/${idProjeto}/send-email`, request);
      const response = handleAxiosResponse<SendEmailProjetoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async downloadProjetoRevisaoArquivoById({ id, nroArquivo }: DownloadArquivoS3Request): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: 'blob' }).get(`/projetos/projetorevisao/${id}/arquivos/${nroArquivo}`);
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  //#endregion

  //#region Projeto revisão resumo
  async getAllProjetoRevisaoResumo(request: GetAllProjetoRevisaoResumoRequest): Promise<GetAllProjetoRevisaoResumoResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/projetorevisao-resumo/list`, request);
      return handleAxiosResponse<GetAllProjetoRevisaoResumoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async createProjetoRevisaoResumo(request: CreateProjetoResumoRevisaoRequest): Promise<CreateProjetoResumoRevisaoResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/projetorevisao-resumo/create`, request);
      return handleAxiosResponse<CreateProjetoResumoRevisaoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async updateProjetoRevisaoResumo(request: UpdateProjetoRevisaoResumoRequest): Promise<UpdateProjetoRevisaoResumoResponse> {
    try {
      const result = await axiosInstance({}).post(`/projetos/projetorevisao-resumo/update`, request);
      return handleAxiosResponse<UpdateProjetoRevisaoResumoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async deleteProjetoRevisaoResumo(request: DeleteProjetoRevisaoResumoRequest): Promise<DeleteProjetoRevisaoResumoResponse> {
    try {
      const result = await axiosInstance({}).delete(`/projetos/projetorevisao-resumo/delete/${request.IdProjetoRevisaoResumo}`);
      return handleAxiosResponse<DeleteProjetoRevisaoResumoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  //#endregion


  async getDisciplinaArquivoById({ idDisciplinaArquivo, imagePosition }: GetArquivoDisciplinaRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: 'blob' }).get(`/projetos/disciplina-arquivos/${idDisciplinaArquivo}/image/${imagePosition}`);
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  async getArqDisciplinaChecklist(request: UpdateDisciplinaChecklistRequest): Promise<Blob> {
    try {
      const result = await axiosInstance({ responseType: 'blob' }).get(`/projetos/disciplina-checklist/arquivo/${request.idDisciplinaChecklist}`);
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }



  //#region DASHBOARD

  async getDashboardProjetosInfo(request: GetDashboardProjetosInfoRequest): Promise<GetDashboardProjetosInfoResponse> {
    try {
      const result = await axiosInstance({}).get(`/dashboard/projetos`);
      return handleAxiosResponse<GetDashboardProjetosInfoResponse>(result);
    } catch (error: unknown) {
      if (typeof error === "string") throw new Error(error);
      else if (isBaseError(error)) throw toBaseError(error);
      else if (error instanceof AxiosError) throw new Error(error.message);
      else if (error instanceof Error) throw error;
      else throw new Error("Falha ao executar requisição!");
    }
  }

  //#endregion
}
